import { render, staticRenderFns } from "./ResponseText.vue?vue&type=template&id=80b14512&"
import script from "./ResponseText.vue?vue&type=script&lang=js&"
export * from "./ResponseText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports